<template>
    <div>
        <transition name="slide-fade">
        <v-card
            v-if="edicion == false"   
            class="mx-auto mt-5"
            max-width="400"
            
        >
        <div class="d-flex justify-end">
            <v-btn @click.prevent="exitsingle" class="mx-2" fab dark small color="primary">
                <v-icon dark>mdi-close</v-icon>
            </v-btn>
        </div>


    <v-list-item three-line>
      <v-list-item-content>
        <v-list-item-title class="headline mb-1">{{datos.valor.name}}</v-list-item-title>
        <div class="overline" style="text-transform: lowercase; font-size: 0.750rem !important">
            {{datos.valor.username?'Coordinador responsable: '+datos.valor.user.name:'roll: Coordinador'}}
        </div>
        <div class="overline mb-4" style="text-transform: lowercase; font-size: 0.750rem !important">
            {{datos.valor.username?'Cuenta de usuario: '+datos.valor.username:'Correo: '+datos.valor.email}}    
        </div>
      </v-list-item-content>
    </v-list-item>

    <v-list-item three-line v-if="datos.valor.userapp">
      <v-list-item-content>
        <v-list-item-title class="headline mb-1">Usuario App</v-list-item-title>
        <div class="overline" style="text-transform: lowercase; font-size: 0.750rem !important">Nombre: {{datos.valor.userapp.name}} </div>
        <div class="overline" style="text-transform: lowercase; font-size: 0.750rem !important">UserName: {{datos.valor.userapp.username}} </div>
        <div class="overline mb-4" style="text-transform: lowercase; font-size: 0.750rem !important">Password: (La misma del dashboard)</div>
      </v-list-item-content>
    </v-list-item>

    <v-card-actions>
        <v-sheet class="pa-5">
            <v-switch  v-if="!datos.valor.username" v-model="switch_dashboard" color="primary" inset :label="`Estado de cuenta Dashboard: ${switch_dashboard == true?'activa':'inactiva'}`"></v-switch>
            <v-switch v-if="datos.valor.userapp||datos.valor.username" v-model="switch_app" color="primary" inset :label="`Estado de cuenta App: ${switch_app == true?'activa':'inactiva'}`"></v-switch>
        </v-sheet>
        
    </v-card-actions>
    <v-card-actions>
         <v-btn
      class="ma-2"
      block
      :loading="loading"
      :disabled="loading"
      color="secondary"
      @click="loader = 'loading'"
    >
      DESABILITAR LA CUENTA
    </v-btn>
    </v-card-actions>

    
      </v-card>
        
    </transition>



    </div>    
</template>
<script>

import {editStatusUser,editStatusAppUser} from '../../../../../services/auth/authenticate'

//console.log(colors);
export default {

    props:{
        datos:''
    },

    mounted() {
      
      

    },

     data(){
       return{
            overlay: false,
            edicion:false,
            images:[],
            dialog: false,
            tipodeitem:['Vehiculo', 'Maquinaria'],  

            switch_dashboard: this.datos.valor.status == 'active'?true:false,
            switch_app: this.datos.valor.userapp? this.datos.valor.userapp.status == 'active'?true:false :this.datos.valor.status == 'active'?true:false,
         }
     },

    watch: {
        
        switch_dashboard(item){
            this.edit('dashboard', item);
        },

        switch_app(item){
            this.edit('app', item);
        }

    },

     methods:{

         exitsingle(){
            this.$store.dispatch('MenuEquipo', false);
          },

          edit(type, item){
             if (type == 'dashboard') {
                 this.$store.dispatch('LoadingFetchActions', true);
                editStatusUser(this.datos.valor.id, {'status':item}).then(response=>{
                    console.log(response);
                    this.$store.dispatch('GetUserSupervisorActions');
                    this.$store.dispatch('GetUserAppActions');
                    this.$store.dispatch('LoadingFetchActions', false);
                }).catch(errors=>{
                    console.log(errors);
                    this.$store.dispatch('LoadingFetchActions', false);
                });    
             }
             if (type == 'app') {
                this.$store.dispatch('LoadingFetchActions', true);  
                 editStatusAppUser(this.datos.valor.username?this.datos.valor.id:this.datos.valor.userapp.id, {'status':item}).then(response=>{
                    console.log(response);
                     this.$store.dispatch('GetUserSupervisorActions');
                     this.$store.dispatch('GetUserAppActions');
                    this.$store.dispatch('LoadingFetchActions', false);
               
               }).catch(errors=>{
                    console.log(errors);
                    this.$store.dispatch('LoadingFetchActions', false);
                });

             }
             
          }

     }
}
</script>